import { Component, Input, Output, EventEmitter, SimpleChange, OnInit, OnChanges, Optional } from '@angular/core';
import { IDropdown, IDropdownEventType, Dropdown, DropdownOption } from './dropdown-model';
import { TranslateService } from '@ngx-translate/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule, FormControl, NgControl } from '@angular/forms';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements ControlValueAccessor, OnInit, OnChanges {
    @Input() id: string; // Id of the dropdown component
    @Input() ddData: Dropdown; // To get the data for the dropdown
    @Input() isDisabled = false; // Defines the enable/disable value of the dropdown
    @Output() ddChange = new EventEmitter<IDropdownEventType>(); // Emits the events when the dropdown options are selected
    @Input() value = '';  // Binds the selected options
    @Input() dropdownMenuWidth?: string; // optional input to provide exclusive width for dropdown menu
    @Input() dropdownMenuHeight?: string; // optional input to provide exclusive height for dropdown menu
    searchTerm?: string;
    previousSelectedValue = '';
    selectedOptionText = '';
    @Input() enableSearch = false;
    @Input() initialSelection: string;
    @Input() addOthersOptions: boolean;
    @Input() showError?: boolean;
    @Input() edited?: boolean;
    translatedText = [];
    constructor(@Optional() private ngControl: NgControl, private translate: TranslateService) {
        translate.get([
            'COMMON.SEARCH'
        ]).subscribe((translations: string) => {
            this.translatedText[0] = translations['COMMON.SEARCH'];
        });
        if (ngControl) {
            ngControl.valueAccessor = this;
        }
    }

    updateData(event) {
        this.searchTerm = event;
    }

    ngOnChanges(changes: { [propName: string]: SimpleChange }) {
        if (changes.showError !== undefined && changes.showError.currentValue !== undefined) {
            this.showError = changes.showError.currentValue;
        }
    }

    ngOnInit() {
        this.updateSelectedOptions();
        this.updateSelectedOptionText();
    }

    updateSelectedOptions() {
        this.previousSelectedValue = '';
        this.ddData.options.forEach(option => {
            if (option.isSelected) {
                this.previousSelectedValue = option.value;
                return;
            }
        });
    }

    changeInDropdown($event, name, value, text) {
        // Bind the new selection
        this.ddData.options.forEach(option => {
            if (!option.isHeader) {
                if (option.isSelected) {
                    this.previousSelectedValue = option.value;
                }
                if (option.value === value) {
                    option.isSelected = true;
                    this.selectedOptionText = option.text;
                } else {
                    option.isSelected = false;
                }
            }
        });
        // Emit the new selection
        this.ddChange.emit({
            name: name,
            value: value,
            text: text,
            previousSelectedValue: this.previousSelectedValue
        });
        // This is required for Reactive forms *** Do not Delete****
        this._onChange(value);
        this._onTouched();
    }

    updateSelectedOptionText() {
        let text = '';
        this.ddData.options.forEach(option => {
            if (option.isSelected) {
                text = option.text;
            }
        });
        this.selectedOptionText = text;
        return text;
    }

    // ControlValueAccessor implementation
    // ====================================

    // call if value was changed inside our component
    private _onChange = (_: any) => {

    }
    // call if input was "touched" .. !
    private _onTouched = () => { };
    // incoming change..
    public writeValue(val: any) {
        this.value = val;
    }

    public registerOnChange(fn: (_: any) => void): void { this._onChange = fn; }
    public registerOnTouched(fn: () => void): void { this._onTouched = fn; }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/dropdown/dropdown.component.ts